/** What a cancellation after the policy's cutoff costs the member (wire string enum). */
export enum LateCancellationOutcome {
  ChargedFull = "ChargedFull",
  ChargedFee = "ChargedFee",
  Waived = "Waived",
}
